module.exports = __webpack_public_path__ + "img/91.d02497c8.png";